import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const cross_104_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path fill="none" stroke={iconColor} d="M6,17.9997 L18,5.9997 M18,17.9997 L6,5.9997" />
    </svg>
  );
};
